import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

export default class Modal extends Component {

    render() {
        const { children, contentLabel, isOpen, className, onClose, staticModal, style } = this.props;

        return (
            <ReactModal
                className={className}
                style={style}
                contentLabel={contentLabel}
                isOpen={isOpen}
                closeTimeoutMS={150}
                onRequestClose={onClose}
                shouldCloseOnOverlayClick={! staticModal}
                ariaHideApp={false} // TODO: fixare la modale senza ariaHideApp che nasconde l'errore in console
            >
                {children}
            </ReactModal>
        );
    }
}

Modal.propTypes = {
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    contentLabel: PropTypes.string,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    staticModal: PropTypes.bool,
    style: PropTypes.object
};

Modal.defaultProps = {
    contentLabel: 'Modal',
    isOpen: false,
    onClose: () => {},
    staticModal: false,
    style: {}
};
